import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import {
  CONVERSATION_STAGE_LABELS,
  getConversationStageOrder,
  isConversationStageLabel,
  normalizeConversationStageLabel,
} from 'dashboard/constants/conversationStages';

export const useConversationStages = () => {
  const accountLabels = useMapGetter('labels/getLabels');

  const stageLabels = computed(() => {
    const savedStages = accountLabels.value.filter(isConversationStageLabel);
    const defaultStages = savedStages.length
      ? []
      : CONVERSATION_STAGE_LABELS.map((title, order) => [
          title,
          { title, order },
        ]);
    const stageMap = new Map(defaultStages);

    savedStages.forEach(label => {
      const title = normalizeConversationStageLabel(label.title);
      stageMap.set(title, {
        title,
        order: getConversationStageOrder(label),
      });
    });

    return [...stageMap.values()]
      .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title))
      .map(stage => stage.title);
  });

  const stageOptions = computed(() =>
    stageLabels.value.map(label => ({
      id: label,
      name: label,
    }))
  );

  return {
    stageLabels,
    stageOptions,
  };
};
